const APP_PAIR = 'app_pair';
const BRANCH_ACCOUNT_ID = 'branch_account_id';
const BRANCH_ACCOUNT_OWNER = 'branch_account_owner';
const CREATED_ON = 'app_created_on';
const DASHBOARD_USER_ID = 'dashboard_user_id';
const LIVE_ID = 'live_id';
const TEST_ID = 'test_id';
const USER_APP_ACCESS = 'user_app_access';

/**
 * Allowable values for Branch Account Service "extend" parameters.
 */
export const EXTENSIONS = {
  APP: {
    CREATED_ON,
  },
  APP_PAIR: {
    BRANCH_ACCOUNT_ID,
    LIVE_ID,
    TEST_ID,
  },
  BRANCH_ACCOUNT: {
    APP_PAIR,
    BRANCH_ACCOUNT_OWNER,
  },
  BRANCH_ACCOUNT_OWNER: {
    BRANCH_ACCOUNT_ID,
    DASHBOARD_USER_ID,
  },
  DASHBOARD_USER: {
    BRANCH_ACCOUNT_ID,
    BRANCH_ACCOUNT_OWNER,
    USER_APP_ACCESS,
  },
  ORGANIZATION: {
    BRANCH_ACCOUNT_ID,
  },
};
